var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.468315 6.62695L21.3711 6.62695L21.3711 5.50324L0.468315 5.50324L0.468315 6.62695Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0893 11.7471C18.4917 9.37604 20.6762 7.51293 23 6.06559C20.6537 4.63848 18.5613 2.70795 17.0893 0.384116L15.6869 0.384116C17.1567 2.63603 18.9277 4.59129 21.1144 6.06559C18.9277 7.56013 17.0893 9.5401 15.6622 11.7471L17.0893 11.7471Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowicon);
export default __webpack_public_path__ + "static/media/arrow icon.15733242.svg";
export { ForwardRef as ReactComponent };